// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1Ag24","resendInfoText":"OnGoingPaymentBox_resendInfoText__1hJSV"};